import { render } from "./OrderDetailsContainer.vue?vue&type=template&id=a18f2324"
import script from "./OrderDetailsContainer.vue?vue&type=script&lang=js"
export * from "./OrderDetailsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__